var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiCard',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Январь 2021")]),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('BarChart',{attrs:{"chart-data":_vm.datacollection,"options":{
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }